import { render, staticRenderFns } from "./G_140_HaisoIrai_Renraku.vue?vue&type=template&id=18b029c3&scoped=true&"
import script from "./G_140_HaisoIrai_Renraku.vue?vue&type=script&lang=ts&"
export * from "./G_140_HaisoIrai_Renraku.vue?vue&type=script&lang=ts&"
import style0 from "./G_140_HaisoIrai_Renraku.vue?vue&type=style&index=0&id=18b029c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b029c3",
  null
  
)

export default component.exports